define('components/course/models/slide-type/tab',[
    "components/course/models/slide-type/zeus-base"
], function(BaseModel) {
    "use strict";

    var TabModel = BaseModel.extend({

        "defaults": function() {
            var baseDefaults = BaseModel.prototype.defaults.call(this),
                defaults = {
                    "isComplete": 0, // State if slide completed by user for submit button at last. Default - 0
                    "type": "tabs",
                    "data": {
                        "saveState": {
                            "tabsVisitedStates": [],
                            "currentlySelectedTabIndex": 0
                        }
                    }
                };
            return _.extend(baseDefaults, defaults);
        },

        "authoringJSONKey": function() {
            return _.extend(BaseModel.prototype.authoringJSONKey.call(this), {
                "data": {
                    "tabsLocation": null,
                    "tabSelected": null,
                    "headerTitle": null,
                    "headerTitleAcc": null,
                    "isHeaderTitleAccSame": null,
                    "headerContent": null,
                    "headerContentAcc": null,
                    "isHeaderContentAccSame": null,
                    "tabsContent": null,
                    "globalComponentData": null
                }
            });
        },

        "initialize": function() {
            this._populateData();
        },

        "_populateData": function() {
            var data = this.get('data');

            if (data === null) {
                this.resetAll();
            }

            if (data && !data.saveState) {
                this.set('data', _.extend(data, this._getSaveStateJSON()));
            }
        },

        "_getDataJson": function() {
            return {
                "tabsLocation": "1", // Location of the tabs whether 1: top 2: left
                "tabSelected": "0", // Current selected tab. Default - 0
                "headerTitle": "",
                "headerTitleAcc": "",
                "isHeaderTitleAccSame": false,
                "headerContent": "",
                "headerContentAcc": "",
                "isHeaderContentAccSame": false,
                "tabsContent": [{
                    "title": "",
                    "header": "",
                    "content": "",
                    "titleIconData": "",
                    "isRead": 0,
                    "nameAcc": "",
                    "isNameAccSame": "",
                    "contentAcc": "",
                    "isContentAccSame": ""
                }, {
                    "title": "",
                    "header": "",
                    "content": "",
                    "titleIconData": "",
                    "isRead": 0,
                    "nameAcc": "",
                    "isNameAccSame": "",
                    "contentAcc": "",
                    "isContentAccSame": ""
                }], //contains { "title": "Tab 1 title", "content": "", "isRead": 0 } array
                "globalComponentData": null
            };
        },

        "_getSaveStateJSON": function() {
            return {
                "saveState": {
                    "tabsVisitedStates": [],
                    "currentlySelectedTabIndex": 0
                }
            };
        },

        /**
         * This resets model attribute to defaults
         * @method resetAll
         **/
        "resetAll": function() {
            this.set('data', _.extend(this._getDataJson(), this._getSaveStateJSON()));
        }
    });
    return TabModel;
});

